import React from 'react';
import { Block } from 'slate';
import BlockTypes, { OT_BLOCKS } from '../../types/BlockTypes';
import Text from '../../components/Text';
import { window } from '../../helpers/BrowserHelpers';
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;

  return [{
    renderBlock: function renderBlock(props, _, next) {
      if (Block.isBlockList(props.node.nodes)) return next();
      var type = props.node.type;
      var isNonOTBlock = !OT_BLOCKS.includes(type);
      var isUnknownBlock = !Object.values(BlockTypes).includes(type);

      if (isUnknownBlock) {
        return React.createElement("div", {
          contentEditable: false,
          className: "border-shade-40 padding-normal flexbox flexbox-align-center radius-normal border-small shade-10 flexbox-centered font-size-normal font-weight-medium"
        }, isMobile ? "This element isn't supported on this version, please update the app to have it." : React.createElement("div", {
          className: "flexbox"
        }, "This element isn't supported on this version, please ", React.createElement(Text.PrimaryAction, {
          onClick: function onClick() {
            return window.location.reload();
          },
          className: "font-size-normal"
        }, "refresh"), ' the app to have it.'));
      } else if (isNonOTBlock) {
        throw new Error("Unknown block type ".concat(type));
      } else {
        return null;
      }
    }
  }];
});